<h1 mat-dialog-title>{{ 'moveAcquisitionsToSession.header' | translate }}</h1>

<button mat-icon-button mat-dialog-close test-id="close-button" class="mat-dialog-close-button">
  <mat-icon>close</mat-icon>
</button>

<mat-dialog-content class="modal-wide">
  <span class="description">{{ 'moveAcquisitionsToSession.labels.description' | translate }}</span>
  <form [formGroup]="form" class="form-full-width">
    <label [id]="elementIds.projectLabel" class="labels">{{ 'moveAcquisitionsToSession.labels.destinationProject' | translate }}</label>
    <mat-form-field appearance="outline">
      <mat-select formControlName="projectId" test-id="project-select"
        [placeholder]="'moveAcquisitionsToSession.labels.selectProject' | translate"
        [aria-labelledby]="elementIds.projectLabel">
        <mat-optgroup *ngFor="let group of groupedProjects$ | async" [label]="group.label">
          <mat-option *ngFor="let project of group.projects" [value]="project._id">{{ project.label }}</mat-option>
        </mat-optgroup>
      </mat-select>
      <mat-error *ngIf="form.get('projectId').hasError('required')">
        {{ 'moveAcquisitionsToSession.errors.projectIdRequired' | translate }}
      </mat-error>
    </mat-form-field>

    <ng-container>
      <div class="label-with-spinner">
        <label [id]="elementIds.existingSubjectLabel" class="labels">{{ 'moveAcquisitionsToSession.labels.destinationSubject' | translate }}</label>
        <fw-progress-spinner *ngIf="updatingProject" size="small" [showValue]="false" mode="indeterminate"></fw-progress-spinner>
      </div>

      <mat-form-field appearance="outline">
        <input type="text" matInput formControlName="existingSubjectId" test-id="existing-subject"
          [matAutocomplete]="subjectAutocomplete"
          [placeholder]="'moveAcquisitionsToSession.labels.selectSubject' | translate"
          (blur)="blurSubjectLabel()">
        <mat-error *ngIf="form.get('existingSubjectId').hasError('required')">
          {{ 'moveAcquisitionsToSession.errors.subjectIdRequired' | translate }}
        </mat-error>
        <mat-error *ngIf="form.get('existingSubjectId').hasError('validSubjectId')">
          {{ 'moveAcquisitionsToSession.errors.subjectIdInvalid' | translate }}
        </mat-error>
        <mat-autocomplete #subjectAutocomplete="matAutocomplete" [displayWith]="displaySubjectLabel">
          <mat-option *ngFor="let subject of filteredSubjects$ | async" [value]="subject._id">
            {{ subject.label || subject._id }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </ng-container>

    <ng-container>
      <div class="label-with-spinner">
        <label [id]="elementIds.existingSessionLabel" class="labels">{{ 'moveAcquisitionsToSession.labels.destinationSession' | translate }}</label>
        <fw-progress-spinner *ngIf="updatingSubject" size="small" [showValue]="false" mode="indeterminate"></fw-progress-spinner>
      </div>
      <mat-form-field appearance="outline">
        <input type="text" matInput formControlName="existingSessionId" test-id="existing-session"
          [matAutocomplete]="sessionAutocomplete"
          [placeholder]="'moveAcquisitionsToSession.labels.selectSession' | translate"
          (blur)="blurSessionLabel()">
        <mat-error *ngIf="form.get('existingSessionId').hasError('required')">
          {{ 'moveAcquisitionsToSession.errors.sessionIdRequired' | translate }}
        </mat-error>
        <mat-error *ngIf="form.get('existingSessionId').hasError('validSessionId')">
          {{ 'moveAcquisitionsToSession.errors.sessionIdInvalid' | translate }}
        </mat-error>
        <mat-error *ngIf="form.get('existingSessionId').hasError('sameSession')">
          {{ 'moveAcquisitionsToSession.errors.sameSession' | translate }}
        </mat-error>
        <mat-autocomplete #sessionAutocomplete="matAutocomplete" [displayWith]="displaySessionLabel">
          <mat-option *ngFor="let session of filteredSessions$ | async" [value]="session._id">
            {{ session.label || session._id }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <mat-checkbox test-id="delete-source" formControlName="deleteEmptySource">{{ 'moveAcquisitionsToSession.labels.deleteSource' | translate }}</mat-checkbox>
    </ng-container>
    <span *ngIf="hasConflictingAcquisitions" class="conflict-warning">
      <mat-icon class="xs" matPrefix>error</mat-icon>{{ 'moveAcquisitionsToSession.errors.conflictWarning' | translate }}
    </span>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button [mat-dialog-close]="false" test-id="dialog-close">
    {{ 'common.actions.cancel' | translate }}
  </button>
  <button mat-flat-button color="primary" test-id="dialog-move"
    [disabled]="!form.valid || saving || updatingProject" (click)="moveSessions()">
    {{ 'common.actions.move' | translate }}
  </button>
</mat-dialog-actions>
